module.exports = __webpack_public_path__ + "static/media/emptyProject_V2Page.49c2ac11.svg";